import {
  pgTable,
  text,
  serial,
  timestamp,
  integer,
  numeric,
} from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";
import { usersTable } from "./users";
import { dealsTable } from "./deals";

export const dealRoomsTable = pgTable("deal_rooms", {
  id: serial("id").primaryKey(),
  title: text("title").notNull(),
  description: text("description"),
  startTime: timestamp("start_time", { withTimezone: true }).notNull(),
  endTime: timestamp("end_time", { withTimezone: true }).notNull(),
  status: text("status", { enum: ["upcoming", "live", "closed"] }).notNull().default("upcoming"),
  accessLevel: text("access_level", { enum: ["vip", "elite", "invite_only"] }).notNull().default("vip"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});

export const dealRoomItemsTable = pgTable("deal_room_items", {
  id: serial("id").primaryKey(),
  dealRoomId: integer("deal_room_id").notNull().references(() => dealRoomsTable.id, { onDelete: "cascade" }),
  dealId: integer("deal_id").notNull().references(() => dealsTable.id, { onDelete: "cascade" }),
  reservePrice: numeric("reserve_price"),
  minimumOffer: numeric("minimum_offer"),
  sellerTerms: text("seller_terms"),
  closingTimeline: text("closing_timeline"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});

export const bidsTable = pgTable("bids", {
  id: serial("id").primaryKey(),
  dealRoomId: integer("deal_room_id").notNull().references(() => dealRoomsTable.id, { onDelete: "cascade" }),
  dealId: integer("deal_id").notNull().references(() => dealsTable.id, { onDelete: "cascade" }),
  investorUserId: integer("investor_user_id").notNull().references(() => usersTable.id),
  offerAmount: numeric("offer_amount").notNull(),
  message: text("message"),
  proofOfFundsUrl: text("proof_of_funds_url"),
  status: text("status", { enum: ["submitted", "shortlisted", "rejected", "accepted"] }).notNull().default("submitted"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});

export const insertDealRoomSchema = createInsertSchema(dealRoomsTable).omit({ id: true, createdAt: true });
export type InsertDealRoom = z.infer<typeof insertDealRoomSchema>;
export type DealRoom = typeof dealRoomsTable.$inferSelect;

export const insertDealRoomItemSchema = createInsertSchema(dealRoomItemsTable).omit({ id: true, createdAt: true });
export type InsertDealRoomItem = z.infer<typeof insertDealRoomItemSchema>;
export type DealRoomItem = typeof dealRoomItemsTable.$inferSelect;

export const insertBidSchema = createInsertSchema(bidsTable).omit({ id: true, createdAt: true });
export type InsertBid = z.infer<typeof insertBidSchema>;
export type Bid = typeof bidsTable.$inferSelect;
